export const playNotification = () => {

    const audio = new Audio("/sounds/notification.mp3");
    audio.currentTime = 0;

    audio.volume = 0.5;

    audio.play().catch(() => {
        console.log("Browser blocked autoplay.");
    });
};